import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CourrierFooter } from 'src/app/utils/interfaces/new/courrier-footer.interface';
import { CourrierHeader } from 'src/app/utils/interfaces/new/courrier-header.interface';
import { CourrierFooterCreate } from 'src/app/utils/interfaces/new/CourrierFooterCreate';
import { CourrierHeaderCreate } from 'src/app/utils/interfaces/new/CourrierHeaderCreate';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderFooterService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };
  private uri = environment.basePath + "/personnalisation/courrier";

  constructor(
    private http: HttpClient,
    private _snack: SnackbarService
  ) { }

  public async findOneFooter(id?: string): Promise<CourrierFooter> {
    try {
      let queryParam = '';
      if (id) {
          queryParam = "?id="+id; 
      }
      const res = await this.http.get(`${this.uri}/footer${queryParam}`, this.httpOptions).toPromise();
      const foot = res.body as CourrierFooter;
      return foot;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findOneHeader(id?:string): Promise<CourrierHeader> {
    try {
      let queryParam = '';
      if (id) {
          queryParam = "?id="+id; 
      }
      const res = await this.http.get(`${this.uri}/header${queryParam}`, this.httpOptions).toPromise();
      const foot = res.body as CourrierHeader;
      return foot;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async createFooter(footer: CourrierFooterCreate): Promise<CourrierFooter> {
    return new Promise<CourrierFooter>(async (resolve, reject) => {
      try {
        const res = await this.http.post<CourrierFooter>(
          this.uri + '/footer',
          footer,
          this.httpOptions
        ).toPromise();
        resolve(res.body);
      } catch (e) {
        this._snack.openSnackBar(e.error.message);
        reject(e);
      }
    });
  }

  public async createHeader(header: CourrierHeaderCreate): Promise<CourrierHeader> {
    return new Promise<CourrierHeader>(async (resolve, reject) => {
      try {
        const res = await this.http.post<CourrierHeader>(
          this.uri + '/header',
          header,
          this.httpOptions
        ).toPromise();
        resolve(res.body);
      } catch (e) {
        this._snack.openSnackBar(e.error.message);
        reject(e);
      }
    });
  }
}
